<template>
  <div>
    <div :id="`flex_${timestamp}_${index}`"></div>
  </div>
</template>

<script>
import { flex2html } from '@/assets/js/flex2html.min.js'
import dayjs from 'dayjs'
export default {
  props: ['value','index'],
  data: () => ({
    timestamp: dayjs().format('x')
  }),
  mounted() {
    if (this.value) {
        try {
            this.value.contents = JSON.parse(this.value.contents)
        } catch (error) {
            
        }
      flex2html(`flex_${this.timestamp}_${this.index}`, this.value)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/LineFlexPreview.vue